// fixed PC locations (office, warehouse, home …): a PC has no GPS and Windows guesses the position from Wi-Fi / internet (often outdated).
// The active location replaces the browser position on desktop PCs and whenever the fix is coarser than 1 km.
const K = 'giss_pc_home', KP = 'giss_pc_places';
const ev = () => window.dispatchEvent(new Event('giss-pc-home'));
export function getPlaces() {
  try {
    const s = JSON.parse(localStorage.getItem(KP));
    if (s) return s;
    const old = JSON.parse(localStorage.getItem(K));
    return old ? { list: [{ id: 'p1', label: '', name: old.name, lat: old.lat, lon: old.lon }], active: old.off ? null : 'p1' } : { list: [], active: null };
  } catch { return { list: [], active: null }; }
}
export const savePlaces = (s) => { localStorage.setItem(KP, JSON.stringify(s)); localStorage.removeItem(K); ev(); };
export const getHome = () => { const s = getPlaces(); return s.list.find((p) => p.id === s.active) || null; };
export const addPlace = (p) => { const s = getPlaces(), id = `p${Date.now()}`; savePlaces({ list: [...s.list, { ...p, id }], active: id }); };
export const activatePlace = (id) => savePlaces({ ...getPlaces(), active: id });
export const removePlace = (id) => { const s = getPlaces(), list = s.list.filter((p) => p.id !== id); savePlaces({ list, active: s.active === id ? list[0]?.id || null : s.active }); };
export const renamePlace = (id, label) => { const s = getPlaces(); savePlaces({ ...s, list: s.list.map((p) => (p.id === id ? { ...p, label } : p)) }); };
export const isDesktop = () => !window.matchMedia?.('(pointer: coarse)').matches && !('ontouchstart' in window);
const active = getHome;
const fake = (h) => ({ coords: { latitude: h.lat, longitude: h.lon, accuracy: 15, altitude: null, altitudeAccuracy: null, heading: null, speed: null }, timestamp: Date.now(), pcHome: true });
let warned = false;
const check = (p) => {
  const h = active();
  if (!getPlaces().list.length && p.coords.accuracy > 1000 && !warned) { warned = true; window.dispatchEvent(new CustomEvent('giss-pc-home-warn', { detail: Math.round(p.coords.accuracy) })); }
  return h && p.coords.accuracy > 1000 ? fake(h) : p;
};

export function installPcHome() {
  const g = navigator.geolocation;
  if (!g || g.pcHome) return;
  const gc = g.getCurrentPosition.bind(g), wp = g.watchPosition.bind(g), cw = g.clearWatch.bind(g);
  let n = 0;
  g.getCurrentPosition = (ok, err, o) => {
    const h = active();
    if (h && isDesktop()) { setTimeout(() => ok(fake(h)), 0); return; }
    gc((p) => ok(check(p)), (e) => (h ? ok(fake(h)) : err?.(e)), o);
  };
  g.watchPosition = (ok, err, o) => {
    const h = active();
    if (h && isDesktop()) { setTimeout(() => ok(fake(h)), 0); n -= 1; return n; }
    return wp((p) => ok(check(p)), (e) => (h ? ok(fake(h)) : err?.(e)), o);
  };
  g.clearWatch = (id) => { if (id >= 0) cw(id); };
  g.pcHome = true;
}
